import React from "react";
import { useUrl } from "@/context/SiteContext";
import ServicePage from "./ServicePage";

export default function AuditMaturitateDigitalaPage() {
  const url = useUrl();
  return (
    <ServicePage
      backLabel="Audituri"
      backTo={url.dept("audituri")}
      number="04"
      eyebrow="Audit digitalizare"
      title={["Audit de", "maturitate", "digitală."]}
      tagline="Digital Maturity Assessment (DMA) — imaginea de ansamblu a nivelului actual de digitalizare, obligatorie pentru proiectele de fonduri europene."
      intro={[
        "Auditul tehnic de maturitate digitală este un pas esențial pentru instituțiile și companiile care depun proiecte în vederea obținerii de fonduri pentru digitalizare.",
        "Instrumentul oferă o imagine de ansamblu a nivelului actual de digitalizare a întreprinderii, iar rezultatele sunt folosite de manageri pentru a stabili strategia de investiții în tehnologii și inovații — precum și măsurile necesare pentru a îndeplini cât mai multe criterii DESI.",
        "Auditul se derulează în două faze: pre-implementare (colectarea datelor înainte de depunerea proiectului) și final (la închiderea implementării, pentru măsurarea impactului).",
      ]}
      bullets={[
        "Infrastructură IT — rețele, servere, stocare, compatibilitate hardware/software.",
        "Fluxuri de lucru digitale și utilizarea soluțiilor ERP, CRM, cloud.",
        "Securitate cibernetică — firewall, politici de acces, backup.",
        "Competențe digitale ale angajaților și alinierea cu strategia de business.",
      ]}
      stepsEyebrow="Ce presupune auditul"
      stepsTitle="Trei zone acoperite integral."
      steps={[
        {
          title: "Infrastructură IT",
          desc: "Analiza rețelelor, serverelor, sistemelor de stocare și verificarea compatibilității cu nevoile actuale și viitoare.",
        },
        {
          title: "Procese & soluții",
          desc: "Evaluarea fluxurilor de lucru digitale, a automatizării proceselor și a soluțiilor IT (ERP, CRM, cloud).",
        },
        {
          title: "Oameni & strategie",
          desc: "Nivelul competențelor digitale ale angajaților și alinierea cu obiectivele generale de business.",
        },
      ]}
      criteriaEyebrow="Ghid de conformitate"
      criteriaTitle="Cele 12 criterii DESI de verificat."
      criteria={[
        "Cel puțin 50% dintre angajați folosesc în scopuri de afaceri calculatoare cu acces la internet.",
        "Dispozitive mobile cu acces la internet pentru cel puțin 20% din personalul angajat.",
        "Utilizarea de specialiști TIC (tehnologia informației și comunicațiilor).",
        "Viteza de download de cel puțin 30 Mb/s.",
        "Vânzările online reprezintă peste 1% din cifra de afaceri totală.",
        "Vânzările web către consumatori privați (B2C) depășesc 10% din totalul vânzărilor prin internet.",
        "Achiziția de servicii cloud computing, sofisticate sau intermediare.",
        "Pagină de internet sau pagină de prezentare online.",
        "Site online cu funcții sofisticate.",
        "Prezență în social media — cel puțin un cont pe o rețea de socializare.",
        "Achiziționarea de servicii de publicitate pe internet.",
        "Trimiterea de facturi electronice pentru procesare automatizată.",
      ]}
      servicesEyebrow="Precizare importantă"
      servicesTitle="Regulă de conformitate."
      services={[
        {
          title: "Auditul final are un semnatar diferit",
          tags: "Regulament aplicabil · asigurarea independenței evaluării.",
          desc: "Auditul final trebuie semnat de un alt specialist IT decât cel care a realizat studiul privind identificarea soluțiilor digitale necesare. SUNTEC dispune de echipe multiple, ceea ce îți permite să respecti această cerință fără a schimba furnizorul.",
        },
      ]}
    />
  );
}
